import React from 'react';
import SweetAlert from "react-bootstrap-sweetalert";

export default function ConfirmCancelAlert(props) {

    const {
        onConfirm,
        onCancel,
        customText
    } = props;

    return (
        <SweetAlert
            warning
            showCancel
            confirmBtnText="Yes, cancel it!"
            confirmBtnBsStyle="danger"
            title={<span className="mb-0 h4">Are you sure?</span>}
            onConfirm={onConfirm} // need to add loading indicator on confirm
            onCancel={onCancel}
            focusCancelBtn
        >
            You will not be able to recover this record!
        {
            customText ?
            <>
                <br />{customText}
            </>
            :
            null
        }
        </SweetAlert>
    );
}



